import { Form, SelectProps } from "antd";
import { useEffect, useState } from "react";

import { _isRequired, parseErrorMessage, renderFiatCurrencyListOptions } from "utils";
import { FiatCurrencyGridDto } from "interfaces";
import { SearchSelect } from "ui";
import { getFiatCurrencyList } from "services";

interface IProps {
  inputProps: SelectProps;
  name: string | string[];
  list?: FiatCurrencyGridDto[];
}

export const FiatCurrencySelect = (props: IProps) => {
  const { inputProps, name, list } = props;
  const [fiatCurrencyList, setFiatCurrencyList] = useState<FiatCurrencyGridDto[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (list && list.length > 0) {
      setFiatCurrencyList(list);
      return;
    } 
    const fetchCurrencyList = async () => {
      setLoading(true);
      await getFiatCurrencyList({ size: 10000, sort: ["order,asc"] })
        .then((res) => {
          if (res.content) {
            setFiatCurrencyList(res.content);
          }
        })
        .catch((e) => {
          console.error(parseErrorMessage(e));
        })
        .finally(() => setLoading(false));
    };

    fetchCurrencyList();
  }, []);

  return (
    <Form.Item name={name} rules={[_isRequired("Выберите валюту договора")]} className="full-width">
      <SearchSelect
        {...inputProps}
        onChange={() => {}}
        loading={loading}
        placeholder="Валюта договора"
        disabled={inputProps.disabled || loading}
        optionLabelProp="label"
      >
        {renderFiatCurrencyListOptions(fiatCurrencyList)}
      </SearchSelect>
    </Form.Item>
  );
};
